<template>
  <header>
    <section>
      <div class="col1">
        <router-link to="/">
          <h3>Artsy</h3>
        </router-link>
        <ul class="inline">
          <li>
            <router-link to="/">Dashboard</router-link>
          </li>

          <li>
            <router-link to="/featured">Featured</router-link>
          </li>
          <li>
            <router-link to="/about">About</router-link>
          </li>
          <li>
            <router-link to="/contact">Contact</router-link>
          </li>

          <li>
            <router-link to="/settings">Settings</router-link>
          </li>
          <li>
            <button
              type="button"
              class="btn btn-default btn-sm"
              @click.prevent="logout()"
            >
              Logout
            </button>
          </li>
        </ul>
      </div>
    </section>
  </header>
</template>

<script>
export default {
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
  },
};
</script>
<style scoped>

</style>
